export { default } from './Fade';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Fade/index.js
// module id = 368
// module chunks = 121